import { useTranslation } from "react-i18next"

// Shared localeText for MUI X DataGrid tables that are used directly (i.e. not
// through the sorted-datagrid-* / wilya-datagrid wrappers, which already inject
// this). Currently localizes the pagination "Rows per page" label. Spread the
// result into the grid's `localeText` prop, keeping any grid-specific keys:
//   const dataGridLocaleText = useDataGridLocaleText()
//   <DataGridPro localeText={{ ...dataGridLocaleText, noRowsLabel: t(...) }} />
// Typed loosely because the app aliases several MUI X majors whose GridLocaleText
// types differ; the shape below is structurally valid for all of them.
export const useDataGridLocaleText = (): {
	MuiTablePagination: { labelRowsPerPage: string }
} => {
	const { t } = useTranslation()
	return {
		MuiTablePagination: {
			labelRowsPerPage: t("common_rows-per-page"),
		},
	}
}
